import HeaderSectionComponent from '@wix/thunderbolt-elements/src/components/Sections/HeaderSection/viewer/HeaderSection';
import HeaderSectionController from '@wix/thunderbolt-elements/src/components/Sections/HeaderSection/viewer/HeaderSection.controller';


const HeaderSection = {
  component: HeaderSectionComponent,
  controller: HeaderSectionController
};


export const components = {
  ['HeaderSection']: HeaderSection
};

